document.addEventListener('DOMContentLoaded', function() {
    var videoWrapper = document.querySelector('.video-wrapper');
    var playButton = document.querySelector('.play-button');
    var videoIframe = document.querySelector('iframe');

    if (playButton && videoWrapper && videoIframe) {
        playButton.addEventListener('click', function() {
            videoWrapper.classList.add('playing');
            videoIframe.src = videoIframe.src + '?autoplay=1';
        });
    }
});